import { render, staticRenderFns } from "./EditSPEmployeeProfileBody.vue?vue&type=template&id=dc5de448&scoped=true"
import script from "./EditSPEmployeeProfileBody.vue?vue&type=script&lang=js"
export * from "./EditSPEmployeeProfileBody.vue?vue&type=script&lang=js"
import style0 from "./EditSPEmployeeProfileBody.vue?vue&type=style&index=0&id=dc5de448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5de448",
  null
  
)

export default component.exports